import React, { Component } from 'react';
import { Box, TextField } from '@mui/material';
import SectionTitle from './SectionTitle';
// import RadioButtonGroup from '../../../../CustomUIObjects/ShopOwnerCustomElements/RadioButtonGroup';
// import PriceInput from './PriceInput';
// import ProductPriceInput from '../../../../CustomUIObjects/ShopOwnerCustomElements/ProductPriceInput';
import RadioButtonGroup from '../../../../../components/RadioButtonGroup';
import ProductPriceInput from '../../../../../components/ProductPriceInput';
import AppPriceInput from '../../../../../components/AppPriceInput';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';

export const DISCOUNT_TYPES = {
    FIX: 'FIX',
    PERCENTAGE: 'PERCENTAGE',
};

const VALUE_KEYS = {
    discountType: 'discountType',
    discountValue: 'discountValue',
    minOrderValue: 'minOrderValue',
    maxDiscountValue: 'maxDiscountValue',
    description: 'description',
    internalDescription: 'internalDescription',
};

const DELETED_KEYS = {
    minOrderValue: 'minOrderDeleted',
    maxDiscountValue: 'maxDiscountDeleted',
};

class DiscountConfigSection extends Component {
    setMyValue = (key, value) => {
        const { editMode, setValue, showAlert } = this.props;

        if (
            editMode &&
            key !== VALUE_KEYS.description &&
            key !== VALUE_KEYS.internalDescription &&
            !Object.values(DELETED_KEYS).includes(key)
        ) {
            // window.alert('Die Daten können nicht bearbeitet werden.');
            showAlert('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
            return;
        }

        setValue?.(key, value);
    };

    render() {
        const {
            discountType,
            discountValue,
            minOrderValue,
            minOrderDeleted,
            maxDiscountDeleted,
            maxDiscountValue,
            discountTypeOptions,
            description,
            internalDescription,
            editMode,
            showAlert
        } = this.props;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/discount_darkgreen.png')}
                    label="Rabatt"
                />

                <RadioButtonGroup
                    key={`${discountType}-${maxDiscountValue}`}
                    selectedKey={discountType}
                    onSelect={(key) => {
                        if (key === DISCOUNT_TYPES.FIX && maxDiscountValue?.length > 0) {
                            // window.alert('Ein Maximalrabatt ist nur bei prozentualem Rabatt möglich.');
                            showAlert('Ein Maximalrabatt ist nur bei prozentualem Rabatt möglich.', ALERT_SEVERITY.WARNING);
                            this.setMyValue(VALUE_KEYS.maxDiscountValue, null);
                        }

                        this.setMyValue(VALUE_KEYS.discountValue, '');
                        this.setMyValue(VALUE_KEYS.discountType, key);
                    }}
                    items={discountTypeOptions}
                />

                <AppPriceInput
                    maxLength={discountType === DISCOUNT_TYPES.FIX ? 4 : 2}
                    value={discountValue}
                    setValue={(val) => this.setMyValue(VALUE_KEYS.discountValue, val)}
                    textInputProps={{ placeholder: 'Wert' }}
                />

                <TextField
                    fullWidth
                    autoComplete="off"
                    value={description?.newValue != null ? description.newValue : (description?.value ?? '')}
                    onChange={(e) => {
                        const text = e.target.value;

                        if (editMode) {
                            if (text !== description?.value) {
                                this.setMyValue(VALUE_KEYS.description, {
                                    value: description?.value ?? '',
                                    newValue: text,
                                });
                            } else {
                                this.setMyValue(VALUE_KEYS.description, {
                                    value: description?.value ?? '',
                                    newValue: null,
                                });
                            }
                        } else {
                            this.setMyValue(VALUE_KEYS.description, {
                                value: text,
                                newValue: null,
                            });
                        }
                    }}
                    placeholder="Beschreibung"
                    size="small"
                />

                <TextField
                    fullWidth
                    autoComplete="off"
                    value={
                        internalDescription?.newValue != null
                            ? internalDescription.newValue
                            : (internalDescription?.value ?? '')
                    }
                    onChange={(e) => {
                        const text = e.target.value;

                        if (editMode) {
                            if (text !== internalDescription?.value) {
                                this.setMyValue(VALUE_KEYS.internalDescription, {
                                    value: internalDescription?.value ?? '',
                                    newValue: text,
                                });
                            } else {
                                this.setMyValue(VALUE_KEYS.internalDescription, {
                                    value: internalDescription?.value ?? '',
                                    newValue: null,
                                });
                            }
                        } else {
                            this.setMyValue(VALUE_KEYS.internalDescription, {
                                value: text,
                                newValue: null,
                            });
                        }
                    }}
                    placeholder="Interne Beschreibung"
                    size="small"
                />

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        <ProductPriceInput
                            minPrice={0}
                            maxLength={5}
                            labelFlex={1.5}
                            value={minOrderDeleted ? '' : minOrderValue}
                            setValue={(val) => this.setMyValue(VALUE_KEYS.minOrderValue, val)}
                            label="Mindestbestellwert"
                            disabled={editMode}
                        />
                    </Box>

                    <Box
                        component="img"
                        src={
                            minOrderValue?.length > 0
                                ? (
                                    minOrderDeleted
                                        ? require('../../../../../assets/icons/undo.png')
                                        : require('../../../../../assets/icons/closered.png')
                                )
                                : require('../../../../../assets/icons/close.png')
                        }
                        alt=""
                        onClick={() => {
                            if (editMode) {
                                this.setMyValue(DELETED_KEYS.minOrderValue, !minOrderDeleted);
                            } else if (minOrderValue?.length > 0) {
                                this.setMyValue(VALUE_KEYS.minOrderValue, '');
                            }
                        }}
                        sx={{
                            width: 20,
                            height: 20,
                            objectFit: 'contain',
                            cursor: 'pointer',
                            flexShrink: 0,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        <ProductPriceInput
                            minPrice={0}
                            maxLength={4}
                            labelFlex={1.5}
                            value={maxDiscountDeleted ? '' : maxDiscountValue}
                            setValue={(val) => {
                                if (discountType === DISCOUNT_TYPES.PERCENTAGE) {
                                    if (val !== '0,00') {
                                        this.setMyValue(VALUE_KEYS.maxDiscountValue, val);
                                    }
                                } else {
                                    // window.alert('Ein Maximalrabatt ist nur bei prozentualem Rabatt möglich.');
                                    showAlert('Ein Maximalrabatt ist nur bei prozentualem Rabatt möglich.', ALERT_SEVERITY.WARNING);
                                }
                            }}
                            label="Maximalrabatt"
                            disabled={editMode || discountType === DISCOUNT_TYPES.FIX} // only 
                        />
                    </Box>

                    <Box
                        component="img"
                        src={
                            maxDiscountValue?.length > 0
                                ? (
                                    maxDiscountDeleted
                                        ? require('../../../../../assets/icons/undo.png')
                                        : require('../../../../../assets/icons/closered.png')
                                )
                                : require('../../../../../assets/icons/close.png')
                        }
                        alt=""
                        onClick={() => {
                            if (editMode) {
                                this.setMyValue(DELETED_KEYS.maxDiscountValue, !maxDiscountDeleted);
                            } else if (maxDiscountValue?.length > 0) {
                                this.setMyValue(VALUE_KEYS.maxDiscountValue, '');
                            }
                        }}
                        sx={{
                            width: 20,
                            height: 20,
                            objectFit: 'contain',
                            cursor: 'pointer',
                            flexShrink: 0,
                        }}
                    />
                </Box>
            </Box>
        );
    }
}

export default DiscountConfigSection;